<template>
  <v-container fluid>
    <div v-if="authState !== 'signedin'">You are signed out.</div>
    <amplify-authenticator>
      <div v-if="authState === 'signedin' && user">
        <v-card>
          <v-card-title class="text-h5"> Applications </v-card-title>
          <v-data-table
            :headers="headers"
            :items="applications"
            item-key="id"
            sort-by="createdAt"
            :sort-desc="[true]"
            :search="search"
            :loading="loading"
            loading-text="Loading Applications..."
            class="AdminApplications"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog persistent v-model="viewDialog" max-width="90%">
                  <v-card>
                    <ViewSingleApplication
                      :application="viewingItem"
                      v-if="viewingItem"
                    />
                    <v-card-actions class="pt-0 pb-3 px-3">
                      <v-spacer />
                      <v-btn color="green" dark @click="viewClose">
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog
                  persistent
                  v-model="applicationNotesDialog"
                  max-width="90%"
                >
                  <v-card>
                    <ApplicationNotes
                      :application="viewingItem"
                      v-if="viewingItem"
                    />
                    <v-card-actions class="px-3 pb-3 pt-0">
                      <v-spacer></v-spacer>
                      <v-btn color="green" dark @click="applicationNotesClose">
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="black"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-2"
                    @click="viewItem(item)"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>View Application</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="black"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-2"
                    @click="applicationNotes(item)"
                  >
                    mdi-text-box-outline
                  </v-icon>
                </template>
                <span>Application Notes</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="black"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-2"
                    @click="downloadPayslip(item)"
                    :disabled="!item.payslips"
                  >
                    mdi-currency-usd
                  </v-icon>
                </template>
                <span>Download Payslip(s)</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="black"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-2"
                    @click="downloadId(item)"
                    :disabled="!item.identification"
                  >
                    mdi-card-account-details
                  </v-icon>
                </template>
                <span>Download Identification/Passport</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="black"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-2"
                    @click="downloadProofOfBank(item)"
                    :disabled="!item.proofOfBank"
                  >
                    mdi-bank
                  </v-icon>
                </template>
                <span>Download Proof Of Banking Account</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="black"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-2"
                    @click="downloadSignatureImage(item)"
                    :disabled="!item.signatureImage"
                  >
                    mdi-file-sign
                  </v-icon>
                </template>
                <span>Download Signature</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="black"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-2"
                    @click="openApplicationLink(item)"
                  >
                    mdi-printer
                  </v-icon>
                </template>
                <span>Print</span>
              </v-tooltip>
            </template>
          </v-data-table>
          <v-card-actions>
            <span class="red--text caption">{{ error }}</span>
          </v-card-actions>
        </v-card>
      </div>
    </amplify-authenticator>
  </v-container>
</template>

<script>
import { layout } from "@/mixins";
import { onAuthUIStateChange } from "@aws-amplify/ui-components";
import { DataStore } from "aws-amplify";
import {
  //   Company,
  // Employee,
  LoanApplication,
  // LoanType
} from "@/models";
import _ from "lodash";
import { Storage } from "@aws-amplify/storage";
import ViewSingleApplication from "@/components/admin/ViewSingleApplication";
import ApplicationNotes from "@/components/admin/ApplicationNotes";

export default {
  mixins: [layout],
  name: "AdminApplications",
  components: {
    ViewSingleApplication,
    ApplicationNotes,
  },
  data: () => ({
    theme: "admin",
    loading: true,
    error: null,
    applications: [],
    user: undefined,
    authState: undefined,
    unsubscribeAuth: undefined,
    search: "",

    viewDialog: false,
    applicationNotesDialog: false,
    viewingItem: {},

    editDialog: false,
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    headers: [
      {
        text: "Created",
        value: "createdAt",
        class: "grey lighten-2",
      },
      {
        text: "Loan Type",
        value: "loanType.code",
      },
      {
        text: "Name",
        value: "employee.name",
        class: "grey lighten-2",
      },
      {
        text: "Surname",
        value: "employee.surname",
      },
      {
        text: "ID Number / Passport",
        value: "employee.idNumber",
        class: "grey lighten-2",
      },
      {
        text: "Company",
        value: "company.name",
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "grey lighten-2",
      },
    ],
  }),
  beforeCreate() {
    this.subscription = DataStore.observe(LoanApplication).subscribe(() => {
      this.queryApplications();
    });
    this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
      this.authState = authState;
      this.user = authData;
      this.queryApplications();
    });
  },
  methods: {
    async queryApplications() {
      try {
        this.subscription = DataStore.observeQuery(LoanApplication).subscribe(
          async (snapshot) => {
            const { items, isSynced } = snapshot;
            if (isSynced && items.length > 0 && !this.applicationNotesDialog) {
              this.loanApplication = _.cloneDeep(items[0]);
              this.applications = _.cloneDeep(items);
              for (let i in this.applications) {
                this.applications[i].createdAt = this.applications[i].createdAt
                  .split(".")[0]
                  .replace("T", " ");
              }
              this.loading = false;
            }
          }
        );
      } catch (err) {
        console.log(err);
      }
    },
    // async queryApplications() {
    //   try {
    //     const modelApplications = await DataStore.query(LoanApplication);
    //     this.applications = _.cloneDeep(modelApplications);
    //     for (let i in this.applications) {
    //       this.applications[i].createdAt = this.applications[i].createdAt
    //         .split(".")[0]
    //         .replace("T", " ");
    //     }

    //     this.loading = false;
    //   } catch (err) {
    //     console.log(err);
    //     this.error = err;
    //   }
    // },
    openApplicationLink(item) {
      window.open("/print/" + item.id, "_blank");
    },
    async downloadProofOfBank(item) {
      try {
        const proofOfBankObject = Object.assign({}, item);
        const downloadedProofOfBank = await Storage.get(
          proofOfBankObject.proofOfBank,
          {
            level: "public",
          }
        );
        window.open(downloadedProofOfBank);
      } catch (error) {
        console.log(error);
      }
    },
    async downloadSignatureImage(item) {
      try {
        const signatureImgObject = Object.assign({}, item);
        const downloadedSignatureImg = await Storage.get(
          signatureImgObject.signatureImage,
          {
            level: "public",
          }
        );
        window.open(downloadedSignatureImg);
      } catch (error) {
        console.log(error);
      }
    },
    async downloadId(item) {
      try {
        const idObject = Object.assign({}, item);
        const downloadedId = await Storage.get(idObject.identification, {
          level: "public",
        });
        window.open(downloadedId);
      } catch (error) {
        console.log(error);
      }
    },
    async downloadPayslip(item) {
      try {
        const payslipObject = Object.assign({}, item);
        for (let i in payslipObject.payslips) {
          const downloadedPayslip = await Storage.get(
            payslipObject.payslips[i],
            {
              level: "public",
            }
          );
          window.open(downloadedPayslip);
        }
      } catch (error) {
        console.log(error);
      }
    },
    viewItem(item) {
      this.viewingItem = Object.assign({}, item);
      this.viewDialog = true;
    },
    applicationNotes(item) {
      this.viewingItem = Object.assign({}, item);
      this.applicationNotesDialog = true;
    },

    editItem(item) {
      this.editedIndex = this.applications.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editDialog = true;
    },
    editClose() {
      this.editDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    viewClose() {
      this.viewingItem = null;
      this.viewDialog = false;
    },
    applicationNotesClose() {
      this.viewingItem = null;
      this.applicationNotesDialog = false;
    },
  },
  watch: {
    editDialog(val) {
      val || this.editClose();
    },
    editDialogDelete(val) {
      val || this.closeDelete();
    },
  },
  beforeDestroy() {
    // this.unsubscribeAuth();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  },
};
</script>

<style>
</style>